import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({

    root: {
        height: '100%',
        backgroundColor: '#F7FAFF',
      },
      
      header: {
        pointerEvents: 'auto',
        zIndex: 6,
      },
      footer: {
        pointerEvents: 'auto',
        zIndex: 5,
      },
    
      mainContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        padding: theme.spacing(3),
        paddingTop: theme.spacing(8),
        paddingBottom: '0',
      },
    
      notificationsDiv: {
        display: 'flex',
        width: '50%',
        justifyContent: 'right',
      },
    
      notificationsButton: {
        borderRadius: '15px',
        width:'2px',
        right:theme.spacing(2),
        '& svg': {
          fill: theme.palette.darkGray.main,
          width: '25px',
          height: '25px',
        }
      },
    
      leftTitle: {
       width: '50%',
       color: theme.palette.darkGray.main,
      },
    
      homeWorkArea: {
        margin: theme.spacing(3),
        padding: theme.spacing(0),
        borderRadius: '15px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
      },
    
      homeWorkAreaIcon: {
        width: '40px',
        height: '40px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: '10px',
        padding: theme.spacing(0.3),
      },
    
      homeWorkAreaHeader: {
        padding: theme.spacing(1),
        fontSize: '10pt',
        color: theme.palette.secondary.main,
      },
    
      cardContentTitle: {
        lineHeight: '0',
      },
    
      homeWorkAreaText: {
        fontSize: '7pt',
        lineHeight: '0',
      },
    
      homeWorkAreaButton: {
        fontSize: '7pt',
        lineHeight: '0',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: '20px',
        display: 'block',
        marginTop: theme.spacing(2),
      },
    
      homeCardsContainer: {
        display: 'flex',
        justifyContent: 'center',
      },
    
      homeCards: {
        margin: theme.spacing(2),
        padding: theme.spacing(0),
        borderRadius: '15px',
        width: '50%',
      },
    
      homeCardsIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        padding: theme.spacing(0.5),
        backgroundColor: theme.palette.primary.main,
        fill: theme.palette.secondary.main,
      },
    
      homeCardsHeader: {
        padding: theme.spacing(1),
        margin: '0',
        fontSize: '10pt'
      }

}));